import { Component, Input } from '@angular/core';
import { ICardInfoData } from '../../../../shared/interfaces/card-info.interface';
import { CommonModule } from '@angular/common';
import { Card } from "../../../../shared/components/card/card";

@Component({
  selector: 'app-healthcare-card-container',
  imports: [CommonModule, Card],
  templateUrl: './healthcare-card-container.html',
  styleUrl: './healthcare-card-container.scss'
})
export class HealthcareCardContainer {

  @Input() cardInfo: ICardInfoData[] = []

}
